<template>
    <div class="modal" @click="outsideClick()">
        <div class="modal-box">
            <div class="close" @click="$emit('close')">
                <span>X</span>
            </div>
            <div class="modal-body">
                <div class="form-box">
                    <div>
                        <h1>Gerar nova senha</h1>
                    </div>
                    <form @submit="handleSubmit">
                        <div class="input-box">
                            <label for="password">Nova senha *</label>
                            <span class="password-icon">
                                <template>
                                    <a-tooltip style="margin:0 5px;">
                                        <template slot="title">
                                            A senha deve ter no mínimo 6 caracteres e ser composta de, ao menos, letras e números.
                                        </template>
                                        <font-awesome-icon :icon="['fa', 'question-circle']"/>
                                    </a-tooltip>
                                </template>
                                <font-awesome-icon :icon="['fa', 'eye-slash']" @click="handleShowPassword(0)"
                                                    v-if="!showPassword"/>
                                <font-awesome-icon :icon="['fa', 'eye']" @click="handleShowPassword(0)" v-if="showPassword"/>
                            </span>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                v-model="form.password"/>
                            <small class="error" v-if="errors && errors.password">{{errors.password.join()}}</small>
                        </div>
                        <div class="input-box">
                            <label for="confirm_password">Confirmar nova senha *</label>
                            <span class="password-icon">
                                    <template>
                                    <a-tooltip style="margin:0 5px;">
                                        <template slot="title">
                                            Lembre-se, as senhas devem coincidir.
                                        </template>
                                        <font-awesome-icon :icon="['fa', 'question-circle']"/>
                                    </a-tooltip>
                                </template>
                                <font-awesome-icon :icon="['fa', 'eye-slash']" @click="handleShowPassword(1)"
                                                    v-if="!showConfirmPassword"/>
                                <font-awesome-icon :icon="['fa', 'eye']" @click="handleShowPassword(1)"
                                                    v-if="showConfirmPassword"/>
                            </span>
                            <input
                                id="confirm_password"
                                name="confirm_password"
                                type="password"
                                v-model="form.password_confirmation"/>
                        </div>
                        <div class="form-actions" v-if="!confirmed">
                            <button @click="handleSubmit" class="button btn-primary" v-if="!loading">Salvar</button>
                            <button class="button btn-purple" disabled v-if="loading">
                                <loading/>
                            </button>
                        </div>
                        <div class="form-box" v-if="confirmed">
                            <div>
                                <p>Sua senha foi alterada com sucesso!.</p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { POST_CUSTOMER } from '../../services/customer'

    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faEye, faEyeSlash, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

    library.add(faEye);
    library.add(faEyeSlash);
    library.add(faQuestionCircle);

    export default {
        name: "news-password-modal",
        components: {  },
        data() {
            return {
                loading: false,
                showPassword: false,
                showConfirmPassword: false,
                confirmed: false,
                form: {
                    password: "",
                    password_confirmation: "",
                },
                errors: [],
            }
        },
        methods: {
            clearErrors() {
                this.errors = [];
            },
            outsideClick() {
                if(event.target === event.currentTarget)
                    this.$emit('close');
            },
            async handleSubmit(event) {
                event.preventDefault();
                this.clearErrors();
                this.loading = true;
                const form = this.form;
                POST_CUSTOMER((form)).then(r => {
                    this.loading = false;
                    this.errors = null;
                    this.confirmed = true;
                }, err => {
                    this.errors = err.response.data;
                    Object.assign(this.errors, err.response.data.errors)
                    this.loading = false;
                });
            },
            handleShowPassword(field) {
                if (field === 0) {
                    this.showPassword = !this.showPassword;
                } else {
                    this.showConfirmPassword = !this.showConfirmPassword;
                }
                const password = field === 0 ? document.getElementById('password') : document.getElementById('confirm_password');
                if (field === 0)
                    if (this.showPassword) {
                        password.type = "text";
                    } else {
                        password.type = "password";
                    }
                if (field === 1)
                    if (this.showConfirmPassword) {
                        password.type = "text";
                    } else {
                        password.type = "password";
                    }
            },
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/NewPasswordModal/NewPasswordModal.vue